import { useShiftsFilter,useCalendarFilters } from '@libs/store/shifts';
import { FilterMenuButton } from '@molecules/filters/filtersMenu';
import { TIMEZONE_FALLBACK } from '@libs/config';
import {
  useDateRangeFilterMenu,
  useProfessionalsFilterMenu,
  useQualificationsFilterMenu,
  useSpecialtyFilterMenu,
  useStatusFilterMenu,
} from '@molecules/filters/filtersMenu';
import { useJobQualificationsData, useJobQualificationsStore } from '@libs/store/talents';
import { useStaffingTypeFilterMenu } from '@molecules/filters/filtersMenu/useStaffingTypeFilterMenu';
import { dateRangeShortcuts } from '@libs/models/common';

type ShiftsFilterMenuProps = {
  mode?: 'list' | 'calendar';
  loading?: boolean;
  timezone?: string;
};

const FallbackTimezone = TIMEZONE_FALLBACK;

export function CalendarShiftsFilterMenu({ loading }: ShiftsFilterMenuProps) {
  const { setFilter, getFilter, filterProviders } = useCalendarFilters();
  const { data: qualificationsOptions } = useJobQualificationsData();
  const { specialties } = useJobQualificationsStore();
  const filterItem = [
    useQualificationsFilterMenu({
      key: 'qualifications',
      localizationSubset: 'shifts.listPage',
      options: qualificationsOptions ?? [],
      getFilter,
    }),
    useSpecialtyFilterMenu({
      localizationSubset: 'shifts.listPage',
      options: specialties ?? [],
      getFilter,
      key: 'specialties',
    }),
    useStatusFilterMenu({
      localizationSubset: 'shifts.listPage',
      getFilter,
      key: 'statuses',
    }),
    useProfessionalsFilterMenu({
      localizationSubset: 'shifts.listPage',
      options: filterProviders ?? [],
      getFilter,
      key: 'staff',
    }),
    useStaffingTypeFilterMenu({
      localizationSubset: 'shifts.listPage',
      getFilter,
      key: 'staffingtypes',
    }),
  ];

  return (
    <FilterMenuButton
      items={filterItem}
      loading={!!loading}
      onFilterApplied={(key, value, label, valueView) => {
        setFilter({
          key,
          value,
          valueView: valueView?.length ? valueView.join(', ') :label,
        });
      }}
    />
  );
}

export function ShiftsFilterMenu({ loading, timezone = FallbackTimezone }: ShiftsFilterMenuProps) {
  const { setFilter, clearFilter, getFilter, filterProviders } = useShiftsFilter();
  const { data: qualificationsOptions } = useJobQualificationsData();
  const { specialties } = useJobQualificationsStore();

  const filterItem = [
    useQualificationsFilterMenu({
      key: 'qualifications',
      localizationSubset: 'shifts.listPage',
      options: qualificationsOptions ?? [],
      getFilter,
    }),
    useSpecialtyFilterMenu({
      localizationSubset: 'shifts.listPage',
      options: specialties ?? [],
      getFilter,
      key: 'specialties',
    }),
    useStatusFilterMenu({
      localizationSubset: 'shifts.listPage',
      getFilter,
      key: 'statuses',
    }),
    useProfessionalsFilterMenu({
      localizationSubset: 'shifts.listPage',
      options: filterProviders ?? [],
      getFilter,
      key: 'staff',
    }),
    useDateRangeFilterMenu({
      setFilter,
      clearFilter,
      dateRangeShortcuts,
      localizationSubset: 'shifts.listPage',
      key: 'startDate',
      timezone,
    }),
  ];

  return (
    <FilterMenuButton
      items={filterItem}
      loading={!!loading}
      onFilterApplied={(key, value, label, valueView) => {
        setFilter({
          key,
          value,
          valueView: valueView?.length ? valueView.join() : label,
        });
      }}
    />
  );
}
